export default {  
    formulario: "FORM",
    menu: "MENU",
    recurso: "RESO"
}